import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const H1Icon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`H1`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M8 3.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8.75H3.417V12a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 1.5 0v3.25H7.25V4A.75.75 0 0 1 8 3.25Zm4.917 2.793a.75.75 0 0 1 1.166.624V12a.75.75 0 0 1-1.5 0V8.067l-.834.557a.75.75 0 0 1-.832-1.248l2-1.333Z"
    />
  </Icon>
);
